import React from "react";
import { Button, Modal, Form } from "react-bootstrap";
import "../css/ChatRoomModal.css";

const WarningModal = (props) => {
  const {
    showWarningModal,
    setShowWarningModal,
    warningTitle,
    warningMessage,
    riskLevel,
    callback,
  } = props;

  return (
    <>
      {/* show popup dialog to user */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showWarningModal}
        onHide={() => {
          setShowWarningModal(false);
          if (callback) {
            callback();
          }
        }}
      >
        {/* Modal header */}
        {riskLevel == 'high' ? <Modal.Header className="modalHeaderHighRisk" closeButton>
          <Modal.Title className="modalTitleHighRisk">{warningTitle}</Modal.Title>
        </Modal.Header> : <Modal.Header closeButton>
          <Modal.Title className="modalTitleWarning">{warningTitle}</Modal.Title>
        </Modal.Header>}
        <Modal.Body><div dangerouslySetInnerHTML={{ __html: warningMessage }} /></Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowWarningModal(false);
              if (callback) {
                callback();
              }
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WarningModal;
